export function sessionRecoveryUrl(origin: string, app: "craneiq" | "repairiq"): string | null {
  try {
    const url = new URL(origin);
    if (url.protocol !== "https:" || url.username || url.password || url.port || url.search || url.hash ||
        !(url.hostname === "onschedule.ca" || url.hostname.endsWith(".onschedule.ca"))) return null;
    return new URL(`/dashboard/open-app/${app}`, url.origin).href;
  } catch { return null; }
}

// A forbidden operation can be a valid user's role restriction. Check the
// session separately; never retry the failed operation, especially a write.
export async function needsSessionRecovery(status: number, check: () => Promise<{ status: number }>): Promise<boolean> {
  if (status !== 401 && status !== 403) return false;
  try {
    const session = await check();
    return session.status === 401 || session.status === 403;
  } catch { return false; }
}

export function showSessionRecovery(app: "craneiq" | "repairiq", origin: string) {
  const href = sessionRecoveryUrl(origin, app);
  if (!href || document.getElementById("suite-session-recovery")) return;
  const notice = document.createElement("aside");
  notice.id = "suite-session-recovery";
  notice.setAttribute("role", "alert");
  notice.style.cssText = "position:sticky;top:0;z-index:1000;padding:1rem;background:#fff8e8;color:#442f0b;border-bottom:2px solid #bf8b25;font:16px/1.5 system-ui";
  const text = document.createElement("p");
  text.style.margin = "0 0 .5rem";
  text.textContent = "Your app session or access needs checking. Saved records are retained. Copy any unsaved entries before leaving this page. Reopen the app through OnSchedule; if access was removed, ask your company administrator.";
  const link = document.createElement("a");
  link.href = href;
  link.textContent = `Reopen ${app === "repairiq" ? "RepairIQ" : "CraneIQ"} through OnSchedule`;
  link.style.cssText = "color:inherit;font-weight:700;text-decoration:underline";
  notice.append(text, link);
  document.body.prepend(notice);
}
